(function () {
  'use strict';

  var SWIPER_SELECTORS = [
    '.collection-list [data-cl-swiper]',
    '[data-testimonial-swiper]',
    '.support-content [data-support-swiper]',
    '.image-content [data-support-swiper]',
    '.brand-logo [data-brand-logo-swiper]',
    '[data-image-gallery-swiper]',
    '[data-grid-banner-swiper]',
    '[data-before-after-swiper]',
    '[data-number-counter-swiper]',
    '[data-pc-swiper]',
    '[data-slideshow-swiper]',
    '[data-fc-swiper]',
    '[data-featured-blog-swiper]'
  ];

  function getInitKey(el) {
    if (el.hasAttribute('data-cl-swiper')) return 'clInit';
    if (el.hasAttribute('data-testimonial-swiper')) return 'testimonialInit';
    if (el.hasAttribute('data-support-swiper')) return 'supportInit';
    if (el.hasAttribute('data-brand-logo-swiper')) return 'brandLogoInit';
    if (el.hasAttribute('data-image-gallery-swiper')) return 'igInit';
    if (el.hasAttribute('data-grid-banner-swiper')) return 'gridBannerInit';
    if (el.hasAttribute('data-before-after-swiper')) return 'baSwiperInit';
    if (el.hasAttribute('data-number-counter-swiper')) return 'numberCounterInit';
    if (el.hasAttribute('data-pc-swiper')) return 'pcSwiperInit';
    if (el.hasAttribute('data-slideshow-swiper')) return 'slideshowInit';
    if (el.hasAttribute('data-fc-swiper')) return 'fcInit';
    if (el.hasAttribute('data-fc-grid-swipe')) return 'fcGridInit';
    if (el.hasAttribute('data-featured-blog-swiper')) return 'blogInit';
    return 'clInit';
  }

  function ownControl(el, selector) { 
    var nodes = el.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].closest('.swiper') === el) return nodes[i];
    }
    return null;
  }

  function prepThemeBlockSlides(el) {
    var wrapper = el.querySelector('.swiper-wrapper');
    if (!wrapper) return 0;

    var count = 0;
    Array.prototype.forEach.call(wrapper.children, function (child) {
      if (!child.classList.contains('shopify-block')) return;
      child.classList.add('swiper-slide');
      count += 1;
    });
    return count;
  }
 
  function destroyAll(root) {
    var scope = root || document;

    SWIPER_SELECTORS.forEach(function (selector) {
      scope.querySelectorAll(selector).forEach(function (el) {
        cancelLazy(el);
        unqueue(el);
        if (el.swiperInstance) {
          el.swiperInstance.destroy(true, true);
          el.swiperInstance = null;
        }
        delete el.dataset[getInitKey(el)];
      });
    });
  }

  function build(el) {
    var initKey = getInitKey(el);
    if (el.dataset[initKey] || !window.Swiper) return;

    
    if (el.hasAttribute('data-fc-grid-swipe')) {
      var fcGap = parseInt(el.dataset.gap, 10) || 0;
      var fcColsMobile = parseInt(el.dataset.colsMobile, 10) || 2;
      el.swiperInstance = new window.Swiper(el, {
        slidesPerView: fcColsMobile,
        spaceBetween: fcGap,
        watchOverflow: true,
        observer: true,
        observeParents: true, 
        a11y: { scrollOnFocus: false }
      });
      el.dataset[initKey] = '1';
      return;
    }

    if (
      el.hasAttribute('data-testimonial-swiper') ||
      el.hasAttribute('data-support-swiper') ||
      el.hasAttribute('data-brand-logo-swiper') ||
      el.hasAttribute('data-image-gallery-swiper') ||
      el.hasAttribute('data-grid-banner-swiper') ||
      el.hasAttribute('data-before-after-swiper') ||
      el.hasAttribute('data-number-counter-swiper') ||
      el.hasAttribute('data-slideshow-swiper') ||
      el.hasAttribute('data-featured-blog-swiper')
    ) {
      prepThemeBlockSlides(el);
    }

    var gap = parseInt(el.dataset.gap, 10) || 0;
    var nav = el.dataset.nav || 'navigation';
    var colsMobile = parseInt(el.dataset.colsMobile, 10) || 1;
    var colsDesktop = parseInt(el.dataset.colsDesktop, 10) || 4;
    var colsLaptop = parseInt(el.dataset.colsLaptop, 10) || 2;
    var colsTablet = parseInt(el.dataset.colsTablet, 10) || 2;
    var peek = parseFloat(el.dataset.peek) || 0;
    var isBeforeAfter = el.hasAttribute('data-before-after-swiper');
    var breakpoints;
    if (isBeforeAfter) {
      breakpoints = {
        0: {
          slidesPerView: 1,
          spaceBetween: gap
        }
      };
    } else if (el.hasAttribute('data-grid-banner-swiper')) {
      breakpoints = {
        0: {
          slidesPerView: colsMobile,
          spaceBetween: gap
        },
        576: {
          slidesPerView: colsTablet,
          spaceBetween: gap
        },
        992: {
          slidesPerView: colsLaptop,
          spaceBetween: gap
        },
        1200: {
          slidesPerView: colsDesktop,
          spaceBetween: gap
        }
      };
    } else if (el.hasAttribute('data-support-swiper')) {
      breakpoints = {
        0: {
          slidesPerView: colsMobile,
          spaceBetween: gap
        },
        576: {
          slidesPerView: colsTablet,
          spaceBetween: gap
        },
        992: {
          slidesPerView: colsLaptop,
          spaceBetween: gap
        },
        1200: {
        slidesPerView: colsLaptop,
        spaceBetween: gap
      },
      1400: {
        slidesPerView: colsDesktop,
        spaceBetween: gap
      }
      };
    } else if (el.hasAttribute('data-image-gallery-swiper')) {
      breakpoints = {
        0: {
          slidesPerView: colsMobile + peek,
          spaceBetween: gap
        },
        576: {
          slidesPerView: colsTablet + peek,
          spaceBetween: gap
        },
        992: {
          slidesPerView: colsLaptop + peek,
          spaceBetween: gap
        },
        1200: {
          slidesPerView: colsDesktop + peek,
          spaceBetween: gap
        }
      };
    } else if (el.hasAttribute('data-testimonial-swiper')) {
      breakpoints = {
        0: {
          slidesPerView: colsMobile + peek,
          spaceBetween: gap
        },
        576: {
          slidesPerView: colsTablet + peek,
          spaceBetween: gap
        },
        992: {
          slidesPerView: colsLaptop + peek,
          spaceBetween: gap
        },
        1200: {
          slidesPerView: colsDesktop + peek,
          spaceBetween: gap
        }
      };
    } else {
      breakpoints = {
        0: {
          slidesPerView: colsMobile,
          spaceBetween: gap
        },
        576: {
          slidesPerView: colsTablet,
          spaceBetween: gap
        },
        992: {
          slidesPerView: colsLaptop,
          spaceBetween: gap
        },
        1400: {
          slidesPerView: colsDesktop,
          spaceBetween: gap
        }
      };
    }
    var opts = {
      slidesPerView: isBeforeAfter ? 1 : colsMobile + (el.hasAttribute('data-testimonial-swiper') ? peek : 0),
      spaceBetween: gap,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      /* Quick-view close restores focus to a button inside a slide;
         scrollOnFocus would slideTo() that slide and jump the carousel. */
      a11y: { scrollOnFocus: false },
      breakpoints: breakpoints
    };

    
    if (el.hasAttribute('data-pc-swiper')) {
      opts.observer = false;
      opts.observeParents = false;
    }


    if (isBeforeAfter) {
      opts.effect = 'fade';
      opts.fadeEffect = { crossFade: true };
      opts.speed = 600;
      opts.allowTouchMove = true;
      opts.noSwipingSelector = '[data-before-after-slider]';
    }

    var slideCount = el.querySelectorAll('.swiper-slide').length;
    var maxPerView = Math.max(colsMobile, colsDesktop);
    if (el.dataset.loop === 'true' && slideCount > maxPerView) { 
      if (el.hasAttribute('data-pc-swiper')) opts.rewind = true;
      else opts.loop = true;
    }

    var ap = parseFloat(el.dataset.autoplay) || 0;
    if (ap > 0) {
      opts.autoplay = {
        delay: ap * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    if (nav === 'navigation' || nav === 'both') {
      opts.navigation = {
        nextEl: ownControl(el, '.swiper-button-next'),
        prevEl: ownControl(el, '.swiper-button-prev')
      };
    }

    if (nav === 'pagination' || nav === 'both') {
      var pagEl = ownControl(el, '.swiper-pagination');
      opts.pagination = {
        el: pagEl,
        clickable: true
      };

      if (pagEl && pagEl.dataset.paginationStyle === 'bold') {
        if (ap > 0) pagEl.style.setProperty('--ring-duration', ap + 's');
        opts.pagination.renderBullet = function (index, className) {
          return (
            '<span class="' + className + ' custom-bullet">' +
            '<svg class="progress-ring" viewBox="0 0 34 34" aria-hidden="true">' +
            '<circle class="progress-ring-bg" cx="17" cy="17" r="16"></circle>' +
            '<circle class="progress-ring-fill" cx="17" cy="17" r="16"></circle>' +
            '</svg>' +
            '<span class="bullet-dot"></span>' +
            '</span>'
          );
        };
      }
    }

    el.swiperInstance = new window.Swiper(el, opts);
    el.dataset[initKey] = '1';

    if (isBeforeAfter && el.dataset.nav === 'thumbnails') {
      buildBeforeAfterThumbs(el, el.swiperInstance);
    }
  }

  
  function buildBeforeAfterThumbs(el, swiper) { 
    var scope = el.closest('.comparison-content__row') || el.parentNode || el;
    var strip = scope.querySelector('[data-before-after-thumbs]');
    if (!strip) return;

    strip.innerHTML = '';

    var goToLabel = strip.dataset.goToSlide || 'Go to slide';
    var slides = el.querySelectorAll('.swiper-slide');
    var buttons = [];

    Array.prototype.forEach.call(slides, function (slide, index) {
      var profile = slide.querySelector('.comparison-profile-slider');

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'comparison-content__thumb';
      button.setAttribute(
        'aria-label',
        (profile && profile.dataset.thumbLabel) || goToLabel + ' ' + (index + 1)
      );

      if (profile) {
        var clone = profile.cloneNode(true);
        clone.removeAttribute('data-thumb-label');
        button.appendChild(clone);
      }

      button.addEventListener('click', function () {
        swiper.slideTo(index);
      });

      button.addEventListener('keydown', function (e) {
        var dir = 0;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
        if (!dir) return;
        e.preventDefault();
        var next = Math.min(buttons.length - 1, Math.max(0, index + dir));
        swiper.slideTo(next);
        buttons[next].focus();
      });

      strip.appendChild(button);
      buttons.push(button);
    });

    function setActive(activeIndex) {
      buttons.forEach(function (btn, i) {
        var active = i === activeIndex;
        btn.classList.toggle('is-active', active);
        if (active) {
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.removeAttribute('aria-current');
        }
      });
    }

    setActive(swiper.realIndex || 0);
    swiper.on('slideChange', function () {
      setActive(swiper.realIndex);
    });
  }

   

  var buildQueue = [];
  var draining = false;

  var scheduleIdle = window.requestIdleCallback
    ? function (cb) { window.requestIdleCallback(cb, { timeout: 500 }); }
    : function (cb) { setTimeout(cb, 0); };

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function unqueue(el) {
    var at = buildQueue.indexOf(el);
    if (at !== -1) buildQueue.splice(at, 1);
  }

  function enqueue(el) {
    if (!el || buildQueue.indexOf(el) !== -1) return;
    buildQueue.push(el);
    scheduleDrain();
  }

  function scheduleDrain() {
    if (draining || !buildQueue.length) return;
    draining = true;
    scheduleIdle(drainOne);
  }

  function drainOne() {
    draining = false;
    var el = buildQueue.shift();
    if (el && el.isConnected) build(el);
    scheduleDrain();
  }

   

  var LAZY_EVENTS = ['pointerenter', 'focusin', 'touchstart'];
  var lazyObserver = null;

  function getLazyObserver() {
    if (lazyObserver || !('IntersectionObserver' in window)) return lazyObserver;

    lazyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          cancelLazy(entry.target);
          enqueue(entry.target);
        });
      },
      { rootMargin: '200px 0px' }
    );
    return lazyObserver;
  }

  function markLazy(el) {
    if (el.dataset.pcLazy || el.dataset[getInitKey(el)]) return;
    el.dataset.pcLazy = '1';

     
    var target = el.closest('.product-card') || el;
    var onInteract = function () {
      cancelLazy(el);
      build(el);
    };

    el.pcLazyTarget = target;
    el.pcLazyHandler = onInteract;
    LAZY_EVENTS.forEach(function (name) {
      target.addEventListener(name, onInteract, { once: true, passive: true });
    });

    var observer = getLazyObserver();
    if (observer) observer.observe(el);
    else enqueue(el);
  }

  function cancelLazy(el) {
    if (!el.dataset.pcLazy) return;
    delete el.dataset.pcLazy;

    if (lazyObserver) lazyObserver.unobserve(el);
    if (el.pcLazyTarget && el.pcLazyHandler) {
      LAZY_EVENTS.forEach(function (name) {
        el.pcLazyTarget.removeEventListener(name, el.pcLazyHandler);
      });
    }
    el.pcLazyTarget = null;
    el.pcLazyHandler = null;
  }

  function initAll(root) {
    var scope = root || document;
    var designMode = isDesignMode();
    var eager = [];
    var deferred = [];

    SWIPER_SELECTORS.forEach(function (selector) {
      scope.querySelectorAll(selector).forEach(function (el) {
        if (!designMode && el.hasAttribute('data-pc-swiper')) deferred.push(el);
        else eager.push(el);
      });
    });
 
    if (designMode) {
      eager.forEach(build);
      return;
    }

    eager.forEach(enqueue);
    deferred.forEach(markLazy);
  }

  function boot(root) {
    if (!window.Swiper) return;
    initAll(root);
  }

  function waitForSwiper(root, attempts) {
    attempts = attempts || 0;

    if (window.Swiper) {
      boot(root);
      return;
    }

    if (attempts < 30) {
      setTimeout(function () {
        waitForSwiper(root, attempts + 1);
      }, 100);
    }
  }

  function onReady() {
    waitForSwiper();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  window.addEventListener('load', onReady);

  document.addEventListener('shopify:section:load', function (e) {
    destroyAll(e.target);
    waitForSwiper(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    destroyAll(e.target);
  });

  document.addEventListener('shopify:section:select', function (e) {
    waitForSwiper(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('.shopify-section');
    if (section) waitForSwiper(section);
  });

  window.SectionCarousel = { 
    initIn: function (root, attempts) {
      if (!root) return;
      if (!window.Swiper) {
        attempts = attempts || 0;
        if (attempts >= 40 || !root.isConnected) return;
        setTimeout(function () {
          window.SectionCarousel.initIn(root, attempts + 1);
        }, 100);
        return;
      }
      initAll(root);
    },
    reinit: function (el, attempts) {
      if (!el) return;
      if (!window.Swiper) {
        attempts = attempts || 0;
        if (attempts >= 40 || !el.isConnected) return;
        setTimeout(function () {
          window.SectionCarousel.reinit(el, attempts + 1);
        }, 100);
        return;
      }
      cancelLazy(el);
      unqueue(el);
      if (el.swiperInstance) {
        el.swiperInstance.destroy(true, true);
        el.swiperInstance = null;
      }
      delete el.dataset[getInitKey(el)];
      build(el);
    }
  };
})();

(function () {
  'use strict';

  function legacyCopy(text) {
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.top = '0';
    field.style.left = '-9999px';
    document.body.appendChild(field);
    field.select();
    field.setSelectionRange(0, text.length);

    var copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    document.body.removeChild(field);
    return copied;
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () {
        if (legacyCopy(text)) return;
        throw new Error('copy-failed');
      });
    }

    return legacyCopy(text) ? Promise.resolve() : Promise.reject(new Error('copy-failed'));
  }

  function setupCopyButton(button) {
    if (!button || button.dataset.rtCopyReady === 'true') return;

    button.dataset.rtCopyReady = 'true';

    button.addEventListener('click', function () {
      var code = button.getAttribute('data-copy-code');
      if (!code) return;

      var codeBox = button.closest('.rich-text__code-box');
      var section = button.closest('.rich-text');
      var successMessage = section ? section.getAttribute('data-copy-success') : '';
      var copiedLabel = codeBox ? codeBox.getAttribute('data-copied-label') : '';
      var copyLabel = button.getAttribute('data-copy-label') || '';
      var feedback = codeBox && codeBox.querySelector('[data-copy-feedback]');

      copyText(code).then(function () {
        if (codeBox) {
          codeBox.classList.add('rich-text__code-box--copied');
          if (copiedLabel) {
            button.setAttribute('aria-label', copiedLabel);
          }
          if (codeBox._rtCopyTimer) {
            window.clearTimeout(codeBox._rtCopyTimer);
          }
          codeBox._rtCopyTimer = window.setTimeout(function () {
            codeBox.classList.remove('rich-text__code-box--copied');
            if (copyLabel) {
              button.setAttribute('aria-label', copyLabel);
            }
            if (feedback) {
              feedback.textContent = '';
            }
          }, 2500);
        }

        if (feedback) {
          feedback.textContent = successMessage || copiedLabel || '';
        }
      }).catch(function () {
        if (codeBox) {
          codeBox.classList.remove('rich-text__code-box--copied');
        }
        if (copyLabel) {
          button.setAttribute('aria-label', copyLabel);
        }
        if (feedback) {
          feedback.textContent = '';
        }

        var codeText = codeBox && codeBox.querySelector('.rich-text__code-text');
        var selection = window.getSelection();

        if (codeText && selection) {
          var range = document.createRange();
          range.selectNodeContents(codeText);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      });
    });
  }

  function initRichText(scope) {
    var root = scope || document;
    root.querySelectorAll('.rich-text__code-copy').forEach(setupCopyButton);
  }

  function onRichTextReady() {
    initRichText();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onRichTextReady);
  } else {
    onRichTextReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initRichText(event.target);
  });
})();

(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (customElements.get('before-after-slider') && customElements.get('before-after-root')) {
    return;
  }

  class BeforeAfterSlider extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('.before-after-comparison__frame');
      this.handle = this.querySelector('.before-after-comparison__handle');
      if (!this.frame || !this.handle) return;

      this.position = Number(this.dataset.initial || this.style.getPropertyValue('--ba-comparison-position') || 50);
      this.position = Math.min(100, Math.max(0, this.position));
      this.setPosition(this.position, true);

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onFrameClick = this.onFrameClick.bind(this);

      this.handle.addEventListener('pointerdown', this.onPointerDown);
      this.frame.addEventListener('click', this.onFrameClick);
      this.handle.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      this.endDrag();
      if (this.handle) {
        this.handle.removeEventListener('pointerdown', this.onPointerDown);
        this.handle.removeEventListener('keydown', this.onKeyDown);
      }
      if (this.frame) {
        this.frame.removeEventListener('click', this.onFrameClick);
      }
    }

    onPointerDown(event) {
      event.preventDefault();
      this.dragging = true;
      this.handle.setPointerCapture(event.pointerId);
      this.handle.addEventListener('pointermove', this.onPointerMove);
      this.handle.addEventListener('pointerup', this.onPointerUp);
      this.handle.addEventListener('pointercancel', this.onPointerUp);
      this.updateFromClientX(event.clientX);
    }

    onPointerMove(event) {
      if (!this.dragging) return;
      event.preventDefault();
      this.updateFromClientX(event.clientX);
    }

    onPointerUp(event) {
      if (!this.dragging) return;
      this.endDrag();
      try {
        this.handle.releasePointerCapture(event.pointerId);
      } catch (error) {
        /* pointer may already be released */
      }
    }

    endDrag() {
      this.dragging = false;
      if (!this.handle) return;
      this.handle.removeEventListener('pointermove', this.onPointerMove);
      this.handle.removeEventListener('pointerup', this.onPointerUp);
      this.handle.removeEventListener('pointercancel', this.onPointerUp);
    }

    onFrameClick(event) {
      if (event.target === this.handle || this.handle.contains(event.target)) return;
      this.updateFromClientX(event.clientX);
    }

    onKeyDown(event) {
      var delta = 0;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') delta = -5;
      if (event.key === 'ArrowRight' || event.key === 'ArrowUp') delta = 5;
      if (event.key === 'Home') {
        event.preventDefault();
        this.setPosition(0);
        return;
      }
      if (event.key === 'End') {
        event.preventDefault();
        this.setPosition(100);
        return;
      }
      if (!delta) return;
      event.preventDefault();
      this.setPosition(this.position + delta);
    }

    updateFromClientX(clientX) {
      var rect = this.frame.getBoundingClientRect();
      if (!rect.width) return;
      var next = ((clientX - rect.left) / rect.width) * 100;
      this.setPosition(next);
    }

    setPosition(value, immediate) {
      var self = this;
      this.position = Math.min(100, Math.max(0, Math.round(value)));
      this.style.setProperty('--ba-comparison-position', this.position + '%');
      if (this.handle) {
        this.handle.setAttribute('aria-valuenow', String(this.position));
      }
      if (!immediate && !REDUCED_MOTION) {
        this.classList.add('is-updating');
        window.clearTimeout(this._updateTimer);
        this._updateTimer = window.setTimeout(function () {
          self.classList.remove('is-updating');
        }, 120);
      }
    }
  }

  class BeforeAfterRoot extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-before-after-category]'));
      this.prevBtn = this.querySelector('[data-before-after-prev]');
      this.nextBtn = this.querySelector('[data-before-after-next]');
      this.dotsRoot = this.querySelector('[data-before-after-dots]');
      this.activeIndex = 0;

      if (this.slides.length <= 1) {
        this.slides.forEach(function (slide) {
          slide.classList.add('is-active');
        });
        this.toggleNav(false);
        return;
      }

      this.onPrev = function () {
        self.goTo(self.activeIndex - 1);
      };
      this.onNext = function () {
        self.goTo(self.activeIndex + 1);
      };

      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
      this.buildDots();
      this.goTo(0, true);
      this.toggleNav(true);
    }

    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
    }

    buildDots() {
      var self = this;
      if (!this.dotsRoot) return;
      this.dotsRoot.innerHTML = '';
      this.slides.forEach(function (slide, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'before-after__dot';
        button.setAttribute('aria-label', slide.dataset.categoryLabel || 'Category ' + (index + 1));
        button.addEventListener('click', function () {
          self.goTo(index);
        });
        self.dotsRoot.appendChild(button);
      });
      this.dotButtons = Array.prototype.slice.call(this.dotsRoot.querySelectorAll('.before-after__dot'));
    }

    goTo(index, immediate) {
      var self = this;
      var max = this.slides.length - 1;
      this.activeIndex = Math.min(max, Math.max(0, index));

      this.slides.forEach(function (slide, i) {
        var active = i === self.activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      if (this.prevBtn) this.prevBtn.disabled = this.activeIndex <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.activeIndex >= max;

      if (this.dotButtons) {
        this.dotButtons.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === self.activeIndex);
          dot.setAttribute('aria-current', i === self.activeIndex ? 'true' : 'false');
        });
      }

      if (!immediate && !REDUCED_MOTION) {
        this.classList.add('is-transitioning');
        window.clearTimeout(this._transitionTimer);
        this._transitionTimer = window.setTimeout(function () {
          self.classList.remove('is-transitioning');
        }, 200);
      }
    }

    toggleNav(show) {
      var nav = this.querySelector('.before-after__nav');
      if (nav) nav.hidden = !show;
    }
  }

  function isBeforeAfterSection(node) {
    return node && node.classList && node.classList.contains('shopify-section--before-after');
  }

  function resetBeforeAfterSection(section) {
    if (!section) return;
    section.querySelectorAll('[data-before-after-root]').forEach(function (root) {
      delete root.dataset.initialized;
    });
  }

  if (!customElements.get('before-after-slider')) {
    customElements.define('before-after-slider', BeforeAfterSlider);
  }
  if (!customElements.get('before-after-root')) {
    customElements.define('before-after-root', BeforeAfterRoot);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!isBeforeAfterSection(event.target)) return;
    resetBeforeAfterSection(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!isBeforeAfterSection(event.target)) return;
    resetBeforeAfterSection(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (!isBeforeAfterSection(event.target)) return;
    resetBeforeAfterSection(event.target);
  });
})();

(function () {
  'use strict';

  var AB_SECTION_CLASS = 'shopify-section--announcement-bar';
  var AB_SELECTOR = '[data-announce-swiper]';

  function prepAnnouncementSlides(swiperEl) {
    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return 0;

    var count = 0;
    Array.prototype.forEach.call(wrapper.children, function (child) {
      if (!child.classList.contains('shopify-block')) return;
      child.classList.add('swiper-slide');
      count += 1;
    });
    return count;
  }

  function destroyAnnouncementBar(root) {
    var scope = root || document;
    scope.querySelectorAll(AB_SELECTOR).forEach(function (el) {
      if (el.swiperInstance) {
        el.swiperInstance.destroy(true, true);
        el.swiperInstance = null;
      }
      delete el.dataset.abInit;
    });
  }

  function buildAnnouncementBar(el) {
    if (el.dataset.abInit || !window.Swiper) return;

    var swiperEl = el.querySelector('.announcement-bar__swiper');
    if (!swiperEl) return;

    prepAnnouncementSlides(swiperEl);

    var nav = el.dataset.nav || 'none';
    var opts = {
      slidesPerView: 1,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      allowTouchMove: el.dataset.swipe !== 'false',
      loop: el.dataset.loop === 'true'
    };

    var delay = parseFloat(el.dataset.autoplay) || 0;
    if (delay > 0) {
      opts.autoplay = {
        delay: delay * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: el.dataset.pauseHover === 'true'
      };
    }

    if (nav === 'navigation' || nav === 'both') {
      opts.navigation = {
        nextEl: swiperEl.querySelector('.swiper-button-next'),
        prevEl: swiperEl.querySelector('.swiper-button-prev')
      };
    }

    if (nav === 'pagination' || nav === 'both') {
      opts.pagination = {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true
      };
    }

    el.swiperInstance = new window.Swiper(swiperEl, opts);
    el.dataset.abInit = '1';
  }

  function initAnnouncementBar(root) {
    var scope = root || document;
    scope.querySelectorAll(AB_SELECTOR).forEach(buildAnnouncementBar);
  }

  function waitForAnnouncementBarSwiper(root, attempts) {
    attempts = attempts || 0;

    if (window.Swiper) {
      initAnnouncementBar(root);
      return;
    }

    if (attempts < 30) {
      setTimeout(function () {
        waitForAnnouncementBarSwiper(root, attempts + 1);
      }, 100);
    }
  }

  function isAnnouncementSection(node) {
    return node && node.classList && node.classList.contains(AB_SECTION_CLASS);
  }

  function onAnnouncementBarReady() {
    waitForAnnouncementBarSwiper();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onAnnouncementBarReady);
  } else {
    onAnnouncementBarReady();
  }

  window.addEventListener('load', onAnnouncementBarReady);

  document.addEventListener('shopify:section:load', function (e) {
    if (!isAnnouncementSection(e.target)) return;
    destroyAnnouncementBar(e.target);
    waitForAnnouncementBarSwiper(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!isAnnouncementSection(e.target)) return;
    destroyAnnouncementBar(e.target);
  });

  document.addEventListener('shopify:section:select', function (e) {
    if (!isAnnouncementSection(e.target)) return;
    waitForAnnouncementBarSwiper(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('.' + AB_SECTION_CLASS);
    if (section) waitForAnnouncementBarSwiper(section);
  });
})();

/* ============================================================
   Shape / wave height  (--shape-height on parent <section>)
   ============================================================ */
(function () {
  'use strict';

  var SHAPE_SELECTOR = '.shape, .wave_shape_top, .wave_shape_bottom';

  function updateShapeHeights(root) {
    if (!window.matchMedia('(min-width: 576px)').matches) return;
    var scope = root || document;
    scope.querySelectorAll(SHAPE_SELECTOR).forEach(function (element) {
      var section = element.closest('section');
      if (section) {
        section.style.setProperty('--shape-height', element.offsetHeight + 'px');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateShapeHeights();
    });
  } else {
    updateShapeHeights();
  }

  window.addEventListener('load', function () {
    updateShapeHeights();
  });

  var shapeResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(shapeResizeTimer);
    shapeResizeTimer = setTimeout(function () {
      updateShapeHeights();
    }, 100);
  });

  document.addEventListener('shopify:section:load', function (e) {
    updateShapeHeights(e.target);
  });

  document.addEventListener('shopify:section:select', function (e) {
    updateShapeHeights(e.target);
  });
})();

/*  Newsletter combined input */
(function () {
  'use strict';

  var NEWSLETTER_SELECTOR = '.newsletter__form-row--combined';
  var MOBILE_QUERY = window.matchMedia('(max-width: 576px)');

  function updateOne(row) {
    var input = row.querySelector('.newsletter__input');
    var button = row.querySelector('.email__button');
    if (!input || !button) return; 
    if (MOBILE_QUERY.matches) {
      input.style.removeProperty('--email-btn-width');
      return;
    }

    var width = button.offsetWidth;
    if (!width) return;
    input.style.setProperty('--email-btn-width', width + 16 + 'px');
  }

  function updateNewsletters(root) {
    var scope = root || document;
    scope.querySelectorAll(NEWSLETTER_SELECTOR).forEach(updateOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateNewsletters();
    });
  } else {
    updateNewsletters();
  }

  window.addEventListener('load', function () {
    updateNewsletters();
  });

  var newsletterResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(newsletterResizeTimer);
    newsletterResizeTimer = setTimeout(function () {
      updateNewsletters();
    }, 100);
  });

  document.addEventListener('shopify:section:load', function (e) {
    updateNewsletters(e.target);
  });

  document.addEventListener('shopify:section:select', function (e) {
    updateNewsletters(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('.shopify-section');
    if (section) updateNewsletters(section);
  });
})();

/* ── Number counter — count-up animation ─────────────────────────────────────
   The number-counter carousel is handled by the shared carousel IIFE above
   (opts in via [data-number-counter-swiper]). This IIFE owns only the count-up
   number animation, driven by an IntersectionObserver. Idles on pages with no
   [data-counter-value] elements. */
(function () {
  'use strict';

  var SECTION_CLASS = 'shopify-section--number-counter';

  function parseCounterValue(raw) {
    /* Extract leading numeric portion; keep suffix for display */
    var match = String(raw).match(/^([0-9,\.]+)(.*)$/);
    if (!match) return null;
    return {
      num:    parseFloat(match[1].replace(/,/g, '')),
      suffix: match[2] || ''
    };
  }

  function formatNumber(n, decimals) {
    if (decimals > 0) return n.toFixed(decimals);
    return Math.round(n).toLocaleString();
  }

  function animateCounter(el) {
    if (el.dataset.ncAnimated) return;
    el.dataset.ncAnimated = '1';

    var raw     = el.dataset.counterValue || el.textContent.trim();
    var parsed  = parseCounterValue(raw);
    if (!parsed) return;

    var end      = parsed.num;
    var suffix   = parsed.suffix;
    var decimals = (String(end).split('.')[1] || '').length;
    var duration = 1600;
    var start    = performance.now();

    function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

    function step(now) {
      var elapsed  = now - start;
      var progress = Math.min(elapsed / duration, 1);
      var current  = end * easeOut(progress);
      el.textContent = formatNumber(current, decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = formatNumber(end, decimals) + suffix;
    }

    requestAnimationFrame(step);
  }

  function animateVisibleCounters(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-counter-value]').forEach(animateCounter);
  }

  function setupObserver(root) {
    if (!('IntersectionObserver' in window)) {
      /* Fallback: animate immediately */
      animateVisibleCounters(root);
      return;
    }

    var scope = root || document;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    scope.querySelectorAll('[data-counter-value]').forEach(function (el) {
      if (!el.dataset.ncAnimated) observer.observe(el);
    });
  }

  function init(root) {
    setupObserver(root);
  }

  function isSection(node) {
    return node && node.classList && node.classList.contains(SECTION_CLASS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  window.addEventListener('load', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) { if (!isSection(e.target)) return; init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { var s = e.target.closest('.' + SECTION_CLASS); if (s) init(s); });
})();
